export default class JSONHelper {
  public static parse<T>(json: string | null | undefined): T | null {
    if (!json) {
      return null;
    }
    try {
      return JSON.parse(json);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static parseFromLocalStorage<T>(key: string): T | null {
    return JSONHelper.parse(localStorage.getItem(key));
  }
}
